export class MajStatutPieceRequest {
    //Création
    constructor() {
        this.pieceIds = [];
    }

    //Identifiants des pièces de vente à générer et transmettre
    public pieceIds: string[];
}